/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: OnWTFNPo14Tf

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { ApiProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/ApiProvider/ApiProvider"; // plasmic-import: TpJbGLILoYYl/codeComponent
import { StateProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/StateProvider/StateProvider"; // plasmic-import: OaGu0RHjgthJ/codeComponent
import Notice from "../../Notice"; // plasmic-import: m89ZcmmDcMEs/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicServiceMessage.module.css"; // plasmic-import: OnWTFNPo14Tf/css

import { getServiceMessage as __fn_getServiceMessage } from "../../../../utils/serviceMessage"; // plasmic-import: getServiceMessage/customFunction

createPlasmicElementProxy;

export type PlasmicServiceMessage__VariantMembers = {};
export type PlasmicServiceMessage__VariantsArgs = {};
type VariantPropType = keyof PlasmicServiceMessage__VariantsArgs;
export const PlasmicServiceMessage__VariantProps = new Array<VariantPropType>();

export type PlasmicServiceMessage__ArgsType = {
  rounded?: boolean;
  stretch?: boolean;
};
type ArgPropType = keyof PlasmicServiceMessage__ArgsType;
export const PlasmicServiceMessage__ArgProps = new Array<ArgPropType>(
  "rounded",
  "stretch"
);

export type PlasmicServiceMessage__OverridesType = {
  serviceDataProvider?: Flex__<typeof ApiProvider>;
  fallbackServiceMessage?: Flex__<typeof StateProvider>;
  fallbackNoticeWrapper?: Flex__<"div">;
  noticeWrapper?: Flex__<"div">;
};

export interface DefaultServiceMessageProps {
  rounded?: boolean;
  stretch?: boolean;
  className?: string;
}

const $$ = {
  getServiceMessage: __fn_getServiceMessage
};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicServiceMessage__RenderFunc(props: {
  variants: PlasmicServiceMessage__VariantsArgs;
  args: PlasmicServiceMessage__ArgsType;
  overrides: PlasmicServiceMessage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          rounded: false,
          stretch: false
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "fallbackServiceMessage.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <ApiProvider
      data-plasmic-name={"serviceDataProvider"}
      data-plasmic-override={overrides.serviceDataProvider}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      alertOnError={true}
      className={classNames(
        "__wab_instance",
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.serviceDataProvider
      )}
      editorMode={"success"}
      enabled={true}
      method={"GET"}
      name={"service"}
      path={"/New/Api.ashx?path=/marketing/service-message"}
      previewData={{
        message:
          "Scheduled maintenance at 5:00 pm EST lasting up to 15 min. Sorry for the inconvenience."
      }}
      refetchIfStale={true}
      refetchOnReconnect={true}
      refetchOnWindowFocus={true}
      retryOnError={true}
      suspense={false}
    >
      <DataCtxReader__>
        {$ctx => (
          <React.Fragment>
            <StateProvider
              data-plasmic-name={"fallbackServiceMessage"}
              data-plasmic-override={overrides.fallbackServiceMessage}
              forceValue={(() => {
                try {
                  return (() => {
                    const serviceMessage = $$.getServiceMessage;
                    return serviceMessage ? serviceMessage() : null;
                  })();
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              onChange={async (...eventArgs: any) => {
                generateStateOnChangeProp($state, [
                  "fallbackServiceMessage",
                  "value"
                ]).apply(null, eventArgs);
              }}
              value={generateStateValueProp($state, [
                "fallbackServiceMessage",
                "value"
              ])}
            />

            {(() => {
              try {
                return !!$state.fallbackServiceMessage.value;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return false;
                }
                throw e;
              }
            })() ? (
              <div
                data-plasmic-name={"fallbackNoticeWrapper"}
                data-plasmic-override={overrides.fallbackNoticeWrapper}
                className={classNames(
                  projectcss.all,
                  sty.fallbackNoticeWrapper
                )}
              >
                <Notice
                  className={classNames("__wab_instance", sty.notice__tNXy7)}
                  message={(() => {
                    try {
                      return $state.fallbackServiceMessage.value;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  noCornerRadius={(() => {
                    try {
                      return !$props.rounded;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()}
                  status={"error"}
                  stretch={(() => {
                    try {
                      return $props.stretch;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()}
                />
              </div>
            ) : null}
            {(() => {
              try {
                return (() => {
                  const serviceData = $ctx.service.data;
                  const fallbackServiceMessage =
                    $state.fallbackServiceMessage.value;
                  return !!(
                    serviceData &&
                    serviceData.message &&
                    !fallbackServiceMessage
                  );
                })();
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return false;
                }
                throw e;
              }
            })() ? (
              <div
                data-plasmic-name={"noticeWrapper"}
                data-plasmic-override={overrides.noticeWrapper}
                className={classNames(projectcss.all, sty.noticeWrapper)}
              >
                <Notice
                  className={classNames("__wab_instance", sty.notice__liYp8)}
                  message={(() => {
                    try {
                      return $ctx.service.data.message;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  noCornerRadius={(() => {
                    try {
                      return !$props.rounded;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()}
                  status={"darkInfo"}
                  stretch={(() => {
                    try {
                      return $props.stretch;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()}
                />
              </div>
            ) : null}
          </React.Fragment>
        )}
      </DataCtxReader__>
    </ApiProvider>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  serviceDataProvider: [
    "serviceDataProvider",
    "fallbackServiceMessage",
    "fallbackNoticeWrapper",
    "noticeWrapper"
  ],
  fallbackServiceMessage: ["fallbackServiceMessage"],
  fallbackNoticeWrapper: ["fallbackNoticeWrapper"],
  noticeWrapper: ["noticeWrapper"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  serviceDataProvider: typeof ApiProvider;
  fallbackServiceMessage: typeof StateProvider;
  fallbackNoticeWrapper: "div";
  noticeWrapper: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicServiceMessage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicServiceMessage__VariantsArgs;
    args?: PlasmicServiceMessage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicServiceMessage__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicServiceMessage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicServiceMessage__ArgProps,
          internalVariantPropNames: PlasmicServiceMessage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicServiceMessage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "serviceDataProvider") {
    func.displayName = "PlasmicServiceMessage";
  } else {
    func.displayName = `PlasmicServiceMessage.${nodeName}`;
  }
  return func;
}

export const PlasmicServiceMessage = Object.assign(
  // Top-level PlasmicServiceMessage renders the root element
  makeNodeComponent("serviceDataProvider"),
  {
    // Helper components rendering sub-elements
    fallbackServiceMessage: makeNodeComponent("fallbackServiceMessage"),
    fallbackNoticeWrapper: makeNodeComponent("fallbackNoticeWrapper"),
    noticeWrapper: makeNodeComponent("noticeWrapper"),

    // Metadata about props expected for PlasmicServiceMessage
    internalVariantProps: PlasmicServiceMessage__VariantProps,
    internalArgProps: PlasmicServiceMessage__ArgProps
  }
);

export default PlasmicServiceMessage;
/* prettier-ignore-end */
